import { render, staticRenderFns } from "./DistintaMultilevel.vue?vue&type=template&id=f922f720&scoped=true&"
import script from "./DistintaMultilevel.vue?vue&type=script&lang=js&"
export * from "./DistintaMultilevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f922f720",
  null
  
)

export default component.exports